const KEY = "sl_source_page";

export function saveSourcePage(from) {
  try {
    localStorage.setItem(KEY, from);
  } catch (e) {}
}

export function getSourcePage() {
  try {
    return localStorage.getItem(KEY) || "direct";
  } catch (e) {
    return "direct";
  }
}
